import defaultTranslations from './locales/en';

const defaultLocale = 'en';
let usedLocale;
let usedTranslations;

async function getTranslationsFileName(locale) {
  let localeToUse = locale;

  // For locales with "-" check does translation file exists, if it doesn't then change locale (ex. pt-BR -> pt)
  if (localeToUse.includes('-')) {
    try {
      await import(`./locales/${localeToUse}`);
    } catch {
      [localeToUse] = localeToUse.split('-');
    }
  }

  switch (localeToUse) {
    case 'sr':
      return 'sr-Latn';
    case 'bs':
      return 'hr';
    default:
      return localeToUse;
  }
}

export async function getTranslations(locale = defaultLocale) {
  usedLocale = await getTranslationsFileName(locale);

  if (usedLocale !== defaultLocale) {
    try {
      const translations = await import(`./locales/${usedLocale}`);

      usedTranslations = Object.assign(defaultTranslations, translations.default);
    } catch {
      usedTranslations = defaultTranslations;
    }
  } else {
    usedTranslations = defaultTranslations;
  }

  return usedTranslations;
}

export function getTranslation(translationKey) {
  return usedTranslations?.[translationKey] || defaultTranslations[translationKey];
}

export function getLocaleFontInfo() {
  switch (usedLocale) {
    case 'bg':
      return {
        name: 'customFontBulgarian',
        assetName: 'customFontBulgarian.fnt',
        specialChars: 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЬЮЯабвгдежзийклмнопрстуфхцчшщъьюя№',
      };
    case 'cs':
      return {
        name: 'customFontCzech',
        assetName: 'customFontCzech.fnt',
        specialChars: 'ÁČĎÉĚÍŇÓŘŠŤÚŮÝŽáčďéěíňóřšťúůýž',
      };
    case 'el':
      return {
        name: 'customFontGreek',
        assetName: 'customFontGreek.fnt',
        specialChars: 'ΆΈΉΊΌΎΏΪΫΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩάέήίόύώϊϋΐΰαβγδεζηθικλμνξοπρςστυφχψω',
      };
    case 'ka':
      return {
        name: 'customFontGeorgian',
        assetName: 'customFontGeorgian.fnt',
        specialChars: 'აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰᲐᲑᲒᲓᲔᲕᲖᲗᲘᲙᲚᲛᲜᲝᲞᲟᲠᲡᲢᲣᲤᲥᲦᲧᲨᲩᲪᲫᲬᲭᲮᲯᲰ',
        // Roboto lacks Georgian glyphs; Noto Sans Georgian covers the script with matching weights.
        googleFamily: 'Noto Sans Georgian',
      };
    case 'nl':
      return {
        name: 'customFontDutch',
        assetName: 'customFontDutch.fnt',
        specialChars: 'ÁÉÍÓÚÀÂÄÇÈÊËÏÎÔÖÙÛÜáéíóúàâäçèêëïîôöùûü',
      };
    case 'pt':
    case 'ro':
      return {
        specialChars: 'ÂĂÁÎȚȘÉÍÓÚÀÒÊÔÃÕÇâăáîțșéíóúàòêôãõç',
      };
    case 'hr':
    case 'me':
    case 'sr-Latn':
      return {
        specialChars: 'ČĆĐŠŽčćđšž',
      };
    case 'es':
      return {
        name: 'customFontSpanish',
        assetName: 'customFontSpanish.fnt',
        specialChars: 'ÑÜÁÉÍÓÚñüáéíóú',
      };
    case 'sk':
      return {
        name: 'customFontSlovak',
        assetName: 'customFontSlovak.fnt',
        specialChars: 'ÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽáäčďéíľĺňóôŕšťúýž',
      };
    case 'sv':
      return {
        name: 'customFontSwedish',
        assetName: 'customFontSwedish.fnt',
        specialChars: 'ÅÄÖåäö',
      };
    default:
      return undefined;
  }
}

export function getUsedLocale() {
  return usedLocale;
}
